import React, { useEffect, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import CustomInput from "../../components/common/Input/Input";
import { useAuthContext } from "../../ContextAPI/AuthContextAPI";
import { api } from "../../api/api";
import axios from "axios";
import { toast } from "react-toastify";
import CustomSelect from "../../components/common/Select/Select";
import { useLocation, useNavigate } from "react-router-dom";
import CustomPopup from "../../components/CustomPopup/CustomPopup";
import TextEditor from "../../components/common/TextEditer/TextEditor";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { v4 as uuidv4 } from "uuid";

const AddCourse = ({ onSubmit }) => {
  const {
    register,
    handleSubmit,
    setValue,
    reset,
    control,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      title: "",
      description: "",
      price: "",
      image: "",
      instructor: "",
      category: "",
      modules: [],
    },
  });
  const { currUserData } = useAuthContext();
  const imageRef = useRef(null);
  const [inputKeys, setInputKeys] = useState({});
  const navigate = useNavigate();
  const [modules, setModules] = useState([
    {
      moduleTitle: "",
      videos: [],
      documents: [], // Ensure documents is always initialized
    },
  ]);
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadingStatus, setUploadingStatus] = useState({});

  const [popupShow, setPopupShow] = useState(false);
  const [filledCourseData, setFilledCourseData] = useState("");

  const [optionsInstructor, setOptionsInstructor] = useState([]);
  const [courses, setCourses] = useState([]);
  const [optionsCategory, setOptionsCategory] = useState([]);

  // const [modules, setModules] = useState([]);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const courseId = queryParams.get("id");
  const [courseData, setCourseData] = useState(null);

  console.log(courseId, "courseId");

  const handleFileUpload = async (event, type, moduleIndex, fileIndex) => {
    const file = event.target.files[0];
    if (!file) return;

    if (type === "image") {
      setUploading(true);
    }
    // setUploadProgress(0);
    const key = `${moduleIndex}_${fileIndex}_${type}`;

    setUploadingStatus((prev) => ({
      ...prev,
      [key]: { uploading: true, progress: 0 },
    }));

    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_ENDPOINT}/api/v1/course/uploadFile`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${currUserData?.token}`,
          },
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / (progressEvent.total || 1)
            );

            if (type === "image") {
              setUploadProgress(percentCompleted);
            }
            // setUploadProgress(percentCompleted);
            setUploadingStatus((prev) => ({
              ...prev,
              [key]: { uploading: true, progress: percentCompleted },
            }));
          },
        }
      );

      if (response && response.data) {
        console.log(response, "file");

        const data = response.data?.data;
        toast.success("File uploaded");

        setModules((prevModules) => {
          const updatedModules = [...prevModules];

          if (type === "image") {
            setValue("image", data.url);
          } else if (type === "video") {
            updatedModules[moduleIndex].videos[fileIndex].videoUrl = data.url;
          } else if (type === "document") {
            updatedModules[moduleIndex].documents[fileIndex].docUrl = data.url;
          }

          setValue("modules", updatedModules); // Sync with react-hook-form
          return updatedModules;
        });
      } else {
        if (type === "image" && imageRef.current) {
          imageRef.current.value = "";
        }
        const key = `${moduleIndex}_${fileIndex}`;
        setInputKeys((prev) => ({
          ...prev,
          [key]: (prev[key] || 0) + 1,
        }));

        toast.error("File not uploaded ");
      }
    } catch (error) {
      if (type === "image" && imageRef.current) {
        imageRef.current.value = "";
      }
      const key = `${moduleIndex}_${fileIndex}`;
      setInputKeys((prev) => ({
        ...prev,
        [key]: (prev[key] || 0) + 1,
      }));

      toast.error("File not uploaded please retry");
    } finally {
      setUploading(false);
      setUploadingStatus((prev) => ({
        ...prev,
        [key]: { uploading: false, progress: 0 },
      }));
    }
  };

  console.log(modules, "moduel");

  const addModule = () => {
    const updatedModules = [
      ...modules,
      { moduleTitle: "", videos: [], documents: [] },
    ];
    setModules(updatedModules);
    setValue("modules", updatedModules); // Sync with react-hook-form
  };
  const addVideo = (moduleIndex) => {
    setModules((prevModules) => {
      const updatedModules = [...prevModules];
      updatedModules[moduleIndex].videos.push({
        title: "",
        videoUrl: "",
        isFreeAccess: false, // Default value
      });

      setValue("modules", updatedModules); // Sync with react-hook-form
      return updatedModules;
    });
  };
  const addDocument = (moduleIndex) => {
    setModules((prevModules) => {
      const updatedModules = [...prevModules];
      if (!updatedModules[moduleIndex].documents) {
        updatedModules[moduleIndex].documents = [];
      }
      updatedModules[moduleIndex].documents.push({
        title: "",
        docUrl: "",
        isFreeAccess: false, // Default value
      });

      setValue("modules", updatedModules); // Sync with react-hook-form
      return updatedModules;
    });
  };

  const removeModule = (moduleIndex) => {
    const updatedModules = modules.filter((_, index) => index !== moduleIndex);
    setModules(updatedModules);
    setValue("modules", updatedModules);
  };

  const removeVideo = (moduleIndex, videoIndex) => {
    const updatedModules = [...modules];
    updatedModules[moduleIndex].videos = updatedModules[
      moduleIndex
    ].videos.filter((_, index) => index !== videoIndex);
    setModules(updatedModules);
    setValue("modules", updatedModules);
  };

  const removeDocument = (moduleIndex, docIndex) => {
    const updatedModules = [...modules];
    updatedModules[moduleIndex].documents = updatedModules[
      moduleIndex
    ].documents.filter((_, index) => index !== docIndex);
    setModules(updatedModules);
    setValue("modules", updatedModules);
  };

  const updateModuleTitle = (moduleIndex, value) => {
    const updatedModules = [...modules];
    updatedModules[moduleIndex].moduleTitle = value;
    setModules(updatedModules);
    setValue("modules", updatedModules); // Sync with react-hook-form
  };

  const updateVideoTitle = (moduleIndex, videoIndex, value) => {
    const updatedModules = [...modules];
    updatedModules[moduleIndex].videos[videoIndex].title = value;
    setModules(updatedModules);
    setValue("modules", updatedModules); // Sync with react-hook-form
  };
  const updateDocumentTitle = (moduleIndex, docIndex, newTitle) => {
    setModules((prevModules) => {
      const updatedModules = [...prevModules];
      updatedModules[moduleIndex].documents[docIndex].title = newTitle;
      setValue("modules", updatedModules); // Sync with react-hook-form
      return updatedModules;
    });
  };

  const toggleDocumentFreeAccess = (moduleIndex, docIndex) => {
    setModules((prevModules) => {
      const updatedModules = [...prevModules];
      updatedModules[moduleIndex].documents[docIndex].isFreeAccess =
        !updatedModules[moduleIndex].documents[docIndex].isFreeAccess;
      setValue("modules", updatedModules); // Sync with react-hook-form
      return updatedModules;
    });
  };
  const toggleFreeAccess = (moduleIndex, videoIndex) => {
    setModules((prevModules) => {
      const updatedModules = [...prevModules];
      updatedModules[moduleIndex].videos[videoIndex].isFreeAccess =
        !updatedModules[moduleIndex].videos[videoIndex].isFreeAccess;

      setValue("modules", updatedModules); // Sync with react-hook-form
      return updatedModules;
    });
  };

  const selectedCourse =
    courseId && courses?.find((course) => course._id === courseId);
  console.log(selectedCourse, "selectedCourse");

  const getCourseData = async (term = "") => {
    // setIsLoading(true);
    let res = await api(
      `api/v1/course/getCourses`,
      "",
      "get",
      currUserData?.token,
      ""
    );
    if (res && res.success) {
      console.log(res, "getCourseData");
      setCourses(res?.data);
      // setTotalCount(res?.totalCourses);
      // setIsLoading(false);
    }
  };
  useEffect(() => {
    if (selectedCourse) {
      initializePlansFromData(selectedCourse);
      setValue("title", selectedCourse.title || "");
      setValue("description", selectedCourse.description || "");
      setValue("instructor", selectedCourse.instructor || null);
      setValue("category", selectedCourse.category || null);
      setValue("learning", selectedCourse.learning || "");
      setValue("about", selectedCourse.about || "");
      setValue("importance", selectedCourse.importance || "");

      // Now populate modules with nested videos and documents
      if (selectedCourse.modules && selectedCourse.modules.length > 0) {
        setModules(selectedCourse.modules);
      }

      const formattedModules = selectedCourse?.content?.map((mod) => ({
        moduleTitle: mod.moduleTitle,
        videos: mod?.videos.map((v) => ({
          title: v.title,
          videoUrl: v.videoUrl,
          isFreeAccess: v.isFreeAccess,
        })),
        documents: mod.documents.map((d) => ({
          title: d.title,
          docUrl: d.docUrl,
          isFreeAccess: d.isFreeAccess,
        })),
      }));

      setValue("image", selectedCourse?.image);

      // Sync both states
      setModules(formattedModules);
      if (selectedCourse?.instructor && optionsInstructor?.length > 0) {
        const matchedInstructor = optionsInstructor.find(
          (opt) => opt.value === selectedCourse.instructor._id
        );
        if (matchedInstructor) {
          setValue("instructor", matchedInstructor);
        }
      }

      if (selectedCourse?.category && optionsCategory?.length > 0) {
        const matchedInstructor = optionsCategory.find(
          (opt) => opt.value === selectedCourse.category._id
        );
        if (matchedInstructor) {
          setValue("category", matchedInstructor);
        }
      }
    }
  }, [selectedCourse]);

  const validateModules = (data) => {
    if (!Array.isArray(modules) || modules.length === 0) {
      toast.warn("At least one module is required.");
      return false;
    }

    for (let i = 0; i < modules.length; i++) {
      const module = modules[i];

      if (!module.moduleTitle?.trim()) {
        toast.warn(`Module ${i + 1}: Title is required.`);
        return false;
      }

      if (!Array.isArray(module.videos) || module.videos.length === 0) {
        toast.warn(`Module ${i + 1}: At least one video is required.`);
        return false;
      }

      for (let j = 0; j < module.videos.length; j++) {
        const video = module.videos[j];
        if (!video.title?.trim() || !video.videoUrl?.trim()) {
          toast.warn(
            `Module ${i + 1}, Video ${j + 1}: Title and URL are required.`
          );
          return false;
        }
      }

      // ❌ No validation for documents (they're optional)
    }

    modules?.forEach((module, moduleIndex) => {
      module.documents?.forEach((document, docIndex) => {
        if (!document.title || !document.docUrl) {
          toast.warn(`please fill document module ${moduleIndex + 1}`);

          return false;
        }
      });
    });

    return true;
  };

  const handleCourseSubmit = async (e) => {
    e.preventDefault();

    const selected = Object.keys(selectedPlans).filter((p) => selectedPlans[p]);
    if (selected.length === 0) {
      alert("Please select at least one plan.");
      return;
    }

    for (let plan of selected) {
      const { price, description } = planDetails[plan];
      if (!price || !description) {
        alert(`Please fill all fields for ${plan} plan.`);
        return;
      }
    }

    const finalPlans = selected.reduce((acc, plan) => {
      acc[plan] = planDetails[plan];
      return acc;
    }, {});

    console.log("Form Submitted with Plans:", finalPlans);

    // console.log(data, modules, "log");

    setPopupShow(false);

    // const stripHtml = (html) => html.replace(/<[^>]*>?/gm, '');

    console.log(filledCourseData, "filledCourseData");

    const buildPayload = () => {
      const payload = {
        title: filledCourseData?.title,
        description: filledCourseData?.description,
        importance: filledCourseData.importance,
        about: filledCourseData.about,
        learning: filledCourseData.learning,

        image: filledCourseData?.image,
        instructor: filledCourseData?.instructor?.value,
        category: filledCourseData?.category?.value,
        // content: modules,
        content: modules.map((module) => ({
          ...module,
          videos: module.videos || [], // likewise for videos
          documents: module.documents || [], // ensure it's an array
        })),
      };

      ["monthly", "quaterly", "yearly"].forEach((term) => {
        const data = finalPlans?.[term];
        if (!data) return;

        if (data?.price) {
          payload[`${term}Price`] = Number(data.price);
        }
        if (data.description) {
          payload[`${term}Description`] = data.description;
        }
      });

      return payload;
    };

    const finalPayload = buildPayload();

    console.log(finalPayload, "finalPayload");

    if (selectedCourse) {
      let res = await api(
        `api/v1/course/updateCourse/${selectedCourse?._id}`,
        finalPayload,
        "put",
        currUserData.token,
        ""
      );
      if (res && res.success) {
        // setSubscriptionData(res?.data);
        console.log(res, "sss");

        // setPopupShow(false);
        reset();
        navigate("/course");
        // getEmployeeData();
      }
    } else {
      let res = await api(
        `api/v1/course/createCourse`,
        finalPayload,
        "post",
        currUserData.token,
        ""
      );
      if (res && res.success) {
        // setSubscriptionData(res?.data);
        console.log(res, "sss");

        // setPopupShow(false);
        reset();
        navigate("/course");
        // getEmployeeData();
      }
    }
  };

  const [selectedPlans, setSelectedPlans] = useState({
    monthly: false,
    quaterly: false,
    yearly: false,
  });

  const [planDetails, setPlanDetails] = useState({
    monthly: { price: "", description: "" },
    quaterly: { price: "", description: "" },
    yearly: { price: "", description: "" },
  });

  const handlePlanToggle = (plan) => {
    setSelectedPlans((prev) => ({
      ...prev,
      [plan]: !prev[plan],
    }));
  };

  const handleInputChange = (plan, field, value) => {
    setPlanDetails((prev) => ({
      ...prev,
      [plan]: {
        ...prev[plan],
        [field]: value,
      },
    }));
  };

  const handleFormSubmit = (data) => {
    console.log(data, "data");

    const onDragEnd = (result) => {
      if (!result.destination) return;

      const items = Array.from(modules);
      const [reorderedItem] = items.splice(result.source.index, 1);
      items.splice(result.destination.index, 0, reorderedItem);

      setModules(items);
      setValue("modules", items); // Sync with react-hook-form
    };

    if (!validateModules(data)) {
      return;
    } else {
      setFilledCourseData(data);
      setPopupShow(true);
    }
  };

  const getEmployeeData = async () => {
    let res = await api(
      `api/v1/employee/getEmployees?page=1&limit=10`,
      "",
      "get",
      currUserData?.token,
      ""
    );
    if (res && res.success) {
      console.log(res, "res res");
      const roleOptions = res.response.map((item) => ({
        label: item.name, // Show "name" in dropdown
        value: item._id, // Return "_id" on select
      }));
      setOptionsInstructor(roleOptions);
    }
  };
  const getCategory = async (term = "") => {
    let res = await api(
      `api/v1/category/getCategories?page=1&limit=10&search=${term}`,
      "",
      "get",
      currUserData?.token,
      ""
    );
    if (res && res.success) {
      console.log(res, "res resgetCategorygetCategorygetCategory");
      const categoryOptions = res.data.map((item) => ({
        label: item.name, // Show "name" in dropdown
        value: item._id, // Return "_id" on select
      }));
      setOptionsCategory(categoryOptions);
    }
  };

  useEffect(() => {
    getEmployeeData();
    getCategory();
    getCourseData();
  }, []);

  const toggleModuleCollapse = (moduleIndex) => {
    const updatedModules = [...modules];
    updatedModules[moduleIndex].isCollapsed =
      !updatedModules[moduleIndex].isCollapsed;
    setModules(updatedModules);
  };
  const registerOptions = {
    title: { required: "Title is required" },
    description: { required: "Description is required" },
    learning: { required: "Learning is required" },
    about: { required: "About is required" },
    importance: { required: "Importance is required" },
    price: { required: "Price is required" },
    phone: {
      required: "Phone Number is required",
      pattern: {
        value: /^[0-9]{10}$/, // Ensures exactly 10 digits
        message: "Enter a valid 10-digit phone number",
      },
    },
  };

  const initializePlansFromData = (data) => {
    const plans = ["monthly", "quaterly", "yearly"];
    const selected = {};
    const details = {};

    plans.forEach((plan) => {
      const priceKey = `${plan}Price`;
      const descKey = `${plan}Description`;

      if (data[priceKey] !== undefined || data[descKey] !== undefined) {
        selected[plan] = true;
        details[plan] = {
          price: data[priceKey] ?? "",
          description: data[descKey] ?? "",
        };
      } else {
        selected[plan] = false;
        details[plan] = { price: "", description: "" };
      }
    });

    setSelectedPlans(selected);
    setPlanDetails(details);
  };

    const handleDragEnd = (result) => {
      if (!result.destination) return;
      const items = Array.from(modules);
      const [reorderedItem] = items.splice(result.source.index, 1);
      items.splice(result.destination.index, 0, reorderedItem);
      setModules(items);
    };

  return (
    <>
      <div className="add_course">
        <div className="p-40">
          <div className="page_heading mb-4">
            <p className="heading">Add Course</p>
          </div>
          <form onSubmit={handleSubmit(handleFormSubmit)}>
            <div className="row">
              <div className="col-6">
                <CustomInput
                  register={register}
                  label="Title"
                  name="title"
                  placeholder="Enter Course Title"
                  type="text"
                  errors={errors.title}
                  validation={registerOptions.title}
                />
              </div>

              <div className="col-6">
                <CustomInput
                  register={register}
                  label="Description"
                  name="description"
                  placeholder="Enter Course Description"
                  type="text"
                  errors={errors.description}
                  validation={registerOptions.description}
                />
              </div>
              <div className="col-6">
                <div className="form_group w-100">
                  <label className="input_lable">Image</label>

                  <div
                    className="custom_input file-upload-container"
                    style={{ position: "relative" }}
                  >
                    {/* Invisible file input for triggering file selection */}
                    <input
                      key={inputKeys?.image || 0}
                      type="file"
                      ref={imageRef}
                      accept="image/*"
                      onChange={(e) => handleFileUpload(e, "image")}
                      className="file-upload-input"
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        opacity: 0,
                        cursor: "pointer",
                      }}
                    />

                    {/* Show image URL or fallback in a disabled text input */}
                    <input
                      type="text"
                      className=""
                      value={watch("image") || "No image selected"}
                      disabled
                      readOnly
                      style={{
                        width: "100%",
                        height: "100%",
                        border: "none",
                        background: "none",
                      }}
                    />
                  </div>

                  {uploading && (
                    <p style={{ fontSize: "13px", marginTop: "4px" }}>
                      Uploading... {uploadProgress}%
                    </p>
                  )}

                  {errors.image && (
                    <span
                      className="error"
                      style={{ color: "red", fontSize: "14px" }}
                    >
                      {errors.image.message}
                    </span>
                  )}
                </div>
              </div>

              <div className="col-6">
                {/* <CustomInput
                register={register}
                label="Instructor ID"
                name="instructor"
                placeholder="Enter Instructor ID"
                type="text"
                errors={errors.instructor}
              /> */}
                <Controller
                  name="instructor"
                  control={control}
                  defaultValue={null}
                  rules={{ required: "Instructor is required" }}
                  render={({ field }) => (
                    <CustomSelect
                      label="Instructor ID"
                      name="instructor"
                      options={optionsInstructor}
                      field={field}
                      customLabel=""
                      errors={errors.instructor}
                    />
                  )}
                />
              </div>
              <div className="col-6">
                {/* <CustomInput
                register={register}
                label="Category ID"
                name="category"
                placeholder="Enter Category ID"
                type="text"
                errors={errors.category}
              /> */}
                <Controller
                  name="category"
                  control={control}
                  defaultValue={null}
                  rules={{ required: "category is required" }}
                  render={({ field }) => (
                    <CustomSelect
                      label="Category ID"
                      name="category"
                      options={optionsCategory}
                      field={field}
                      customLabel=""
                      errors={errors.category}
                    />
                  )}
                />
              </div>

              {/* <div className="col-12">
                <label class="input_lable">Learning</label>
                <textarea
                  id="learning"
                  name="learning"
                  {...register("learning", registerOptions.learning)}
                  rows="2"
                  cols="50"
                  className="custom_input"
                  placeholder="learning"
                ></textarea>
                {errors.learning && (
                  <span
                    className="error"
                    style={{ color: "red", fontSize: "14px" }}
                  >
                    {errors.learning.message}
                  </span>
                )}
              </div>
              <div className="col-12">
                <label class="input_lable">About</label>
                <textarea
                  id="about"
                  name="about"
                  {...register("about", registerOptions.about)}
                  rows="2"
                  cols="50"
                  className="custom_input"
                  placeholder="about"
                ></textarea>
                {errors.about && (
                  <span
                    className="error"
                    style={{ color: "red", fontSize: "14px" }}
                  >
                    {errors.about.message}
                  </span>
                )}
              </div>
              <div className="col-12">
                <label class="input_lable">Importance</label>
                <textarea
                  id="importance"
                  name="importance"
                  {...register("importance", registerOptions.importance)}
                  rows="2"
                  cols="50"
                  className="custom_input"
                  placeholder="importance"
                ></textarea>
                {errors.importance && (
                  <span
                    className="error"
                    style={{ color: "red", fontSize: "14px" }}
                  >
                    {errors.importance.message}
                  </span>
                )}
              </div> */}

              <TextEditor
                name="learning"
                label="Learning"
                control={control}
                rules={registerOptions.learning}
                errors={errors}
              />

              <TextEditor
                name="about"
                label="About"
                control={control}
                rules={registerOptions.about}
                errors={errors}
              />

              <TextEditor
                name="importance"
                label="Importance"
                control={control}
                rules={registerOptions.importance}
                errors={errors}
              />

              <div className="page_heading mb-2 mt-4">
                <p className="heading">Course Content</p>
                <button className="btn_blue" type="button" onClick={addModule}>
                  Add Module
                </button>
              </div>

              <DragDropContext onDragEnd={handleDragEnd}>
                <Droppable droppableId="modules">
                  {(provided) => (
                    <div {...provided.droppableProps} ref={provided.innerRef}>
                      {modules &&
                        modules.map((module, moduleIndex) => (
                          <Draggable
                            key={moduleIndex}
                            draggableId={`module-${moduleIndex}`}
                            index={moduleIndex}
                          >
                            {(provided) => (
                              <div
                                className="module-container mb-4"
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                              >
                                <div
                                  className="module-header"
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    padding: "10px",
                                    backgroundColor: "#f5f5f5",
                                    borderRadius: "5px",
                                    cursor: "pointer",
                                    border: "1px solid #ddd",
                                  }}
                                  onClick={() =>
                                    toggleModuleCollapse(moduleIndex)
                                  }
                                >
                                  <div className="d-flex align-items-center">
                                    <span
                                      style={{
                                        fontSize: "20px",
                                        fontWeight: "600",
                                        marginRight: "10px",
                                      }}
                                    >
                                      ({moduleIndex + 1})
                                    </span>
                                    <label className="input_lable mb-0">
                                      {module.moduleTitle || "Untitled Module"}
                                    </label>
                                  </div>

                                  <div>
                                    <button
                                      type="button"
                                      className="btn_red_text me-2"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        removeModule(moduleIndex);
                                      }}
                                    >
                                      Remove Module
                                    </button>
                                    <button
                                      type="button"
                                      className="btn_blue"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        toggleModuleCollapse(moduleIndex);
                                      }}
                                    >
                                      {module.isCollapsed
                                        ? "Expand ▼"
                                        : "Collapse ▲"}
                                    </button>
                                  </div>
                                </div>

                                {!module.isCollapsed && (
                                  <div
                                    className="module-content"
                                    style={{
                                      padding: "15px",
                                      border: "1px solid #eee",
                                      borderTop: "none",
                                      borderRadius: "0 0 5px 5px",
                                    }}
                                  >
                                    <input
                                      type="text"
                                      className="custom_input mt-3"
                                      value={modules[moduleIndex].moduleTitle}
                                      onChange={(e) =>
                                        updateModuleTitle(
                                          moduleIndex,
                                          e.target.value
                                        )
                                      }
                                      placeholder="Enter Module Title"
                                    />
                                    {errors.modules?.[moduleIndex]
                                      ?.moduleTitle && (
                                      <p className="error">
                                        {
                                          errors.modules[moduleIndex]
                                            .moduleTitle.message
                                        }
                                      </p>
                                    )}

                                    {/* Videos */}
                                    <div className="page_heading mb-2 mt-4">
                                      <p className="heading">Videos</p>
                                    </div>

                                    {module.videos.map((video, videoIndex) => (
                                      <div
                                        key={videoIndex}
                                        className="video-container mb-4 p-3"
                                        style={{
                                          border: "1px solid #eee",
                                          borderRadius: "5px",
                                        }}
                                      >
                                        <div className="row">
                                          <div className="col-6">
                                            <div className="form_group w-100">
                                              <div className="d-flex justify-content-between align-items-center">
                                                <label className="input_lable">
                                                  Video Title
                                                </label>
                                                <button
                                                  type="button"
                                                  className="btn_red_text"
                                                  onClick={() =>
                                                    removeVideo(
                                                      moduleIndex,
                                                      videoIndex
                                                    )
                                                  }
                                                >
                                                  Remove Video
                                                </button>
                                              </div>
                                              <input
                                                type="text"
                                                className="custom_input"
                                                value={
                                                  modules[moduleIndex]?.videos[
                                                    videoIndex
                                                  ]?.title || ""
                                                }
                                                onChange={(e) =>
                                                  updateVideoTitle(
                                                    moduleIndex,
                                                    videoIndex,
                                                    e.target.value
                                                  )
                                                }
                                                placeholder="Enter Video Title"
                                              />
                                              {errors.modules?.[moduleIndex]
                                                ?.videos?.[videoIndex]
                                                ?.title && (
                                                <p className="error">
                                                  {
                                                    errors.modules[moduleIndex]
                                                      .videos[videoIndex].title
                                                      .message
                                                  }
                                                </p>
                                              )}
                                            </div>
                                          </div>
                                          <div className="col-6">
                                            <div className="form_group w-100">
                                              <label className="input_lable">
                                                Video
                                              </label>
                                              <div className="custom_input file-upload-container">
                                                <input
                                                  key={
                                                    inputKeys[
                                                      `${moduleIndex}_${videoIndex}`
                                                    ] || 0
                                                  }
                                                  id={`video-upload-${moduleIndex}-${videoIndex}`}
                                                  type="file"
                                                  accept="video/mp4,video/mkv,video/*"
                                                  onChange={(e) =>
                                                    handleFileUpload(
                                                      e,
                                                      "video",
                                                      moduleIndex,
                                                      videoIndex
                                                    )
                                                  }
                                                  className="file-upload-input d-none"
                                                />
                                                <label
                                                  htmlFor={`video-upload-${moduleIndex}-${videoIndex}`}
                                                  style={{
                                                    cursor: "pointer",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                  }}
                                                  title={
                                                    modules?.[moduleIndex]
                                                      ?.videos?.[videoIndex]
                                                      ?.videoUrl ||
                                                    "Choose file"
                                                  }
                                                >
                                                  {modules?.[moduleIndex]
                                                    ?.videos?.[videoIndex]
                                                    ?.videoUrl
                                                    ? modules[moduleIndex]
                                                        .videos[videoIndex]
                                                        .videoUrl
                                                    : "Choose file"}
                                                </label>
                                                {uploadingStatus[
                                                  `${moduleIndex}_${videoIndex}_video`
                                                ]?.uploading && (
                                                  <p>
                                                    Uploading...{" "}
                                                    {uploadingStatus[
                                                      `${moduleIndex}_${videoIndex}_video`
                                                    ]?.progress || 0}
                                                    %
                                                  </p>
                                                )}
                                              </div>
                                            </div>
                                          </div>

                                          <div className="form_group w-100 d-flex align-items-center mt-2">
                                            <label className="input_lable me-2">
                                              Free Access:
                                            </label>
                                            <input
                                              type="checkbox"
                                              checked={video.isFreeAccess}
                                              onChange={() =>
                                                toggleFreeAccess(
                                                  moduleIndex,
                                                  videoIndex
                                                )
                                              }
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    ))}

                                    <div className="page_heading mb-2 mt-4">
                                      <button
                                        className="btn_blue"
                                        type="button"
                                        onClick={() => addVideo(moduleIndex)}
                                      >
                                        Add Videos
                                      </button>
                                    </div>

                                    {/* Documents */}
                                    <div className="page_heading mb-2 mt-4">
                                      <p className="heading">Documents</p>
                                    </div>

                                    {module.documents?.map(
                                      (document, docIndex) => (
                                        <div
                                          key={docIndex}
                                          className="document-container mb-4 p-3"
                                          style={{
                                            border: "1px solid #eee",
                                            borderRadius: "5px",
                                          }}
                                        >
                                          <div className="row">
                                            <div className="col-6">
                                              <div className="form_group w-100">
                                                <div className="d-flex justify-content-between align-items-center">
                                                  <label className="input_lable">
                                                    Document Title
                                                  </label>
                                                  <button
                                                    type="button"
                                                    className="btn_red_text"
                                                    onClick={() =>
                                                      removeDocument(
                                                        moduleIndex,
                                                        docIndex
                                                      )
                                                    }
                                                  >
                                                    Remove Document
                                                  </button>
                                                </div>
                                                <input
                                                  type="text"
                                                  className="custom_input"
                                                  value={
                                                    modules[moduleIndex]
                                                      .documents[docIndex].title
                                                  }
                                                  onChange={(e) =>
                                                    updateDocumentTitle(
                                                      moduleIndex,
                                                      docIndex,
                                                      e.target.value
                                                    )
                                                  }
                                                  placeholder="Enter Document Title"
                                                />
                                                {errors.modules?.[moduleIndex]
                                                  ?.documents?.[docIndex]
                                                  ?.title && (
                                                  <p className="error">
                                                    {
                                                      errors.modules[
                                                        moduleIndex
                                                      ].documents[docIndex]
                                                        .title.message
                                                    }
                                                  </p>
                                                )}
                                              </div>
                                            </div>
                                            <div className="col-6">
                                              <div className="form_group w-100">
                                                <label className="input_lable">
                                                  Upload Document
                                                </label>
                                                <div className="custom_input file-upload-container">
                                                  <input
                                                    type="file"
                                                    accept=".pdf,.doc,.docx"
                                                    onChange={(e) =>
                                                      handleFileUpload(
                                                        e,
                                                        "document",
                                                        moduleIndex,
                                                        docIndex
                                                      )
                                                    }
                                                    className="file-upload-input"
                                                  />
                                                  {uploadingStatus[
                                                    `${moduleIndex}_${docIndex}_document`
                                                  ]?.uploading && (
                                                    <p>
                                                      Uploading...{" "}
                                                      {uploadingStatus[
                                                        `${moduleIndex}_${docIndex}_document`
                                                      ]?.progress || 0}
                                                      %
                                                    </p>
                                                  )}
                                                </div>
                                              </div>
                                            </div>

                                            <div className="form_group w-100 d-flex align-items-center mt-2">
                                              <label className="input_lable me-2">
                                                Free Access:
                                              </label>
                                              <input
                                                type="checkbox"
                                                checked={
                                                  document.isFreeAccess ?? false
                                                }
                                                onChange={() =>
                                                  toggleDocumentFreeAccess(
                                                    moduleIndex,
                                                    docIndex
                                                  )
                                                }
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      )
                                    )}

                                    <div className="page_heading mb-2 mt-4">
                                      <button
                                        className="btn_blue"
                                        type="button"
                                        onClick={() => addDocument(moduleIndex)}
                                      >
                                        Add Document
                                      </button>
                                    </div>
                                  </div>
                                )}
                              </div>
                            )}
                          </Draggable>
                        ))}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>

              <button type="submit" className="btn_primary btn_lg mt-5 mx-auto">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
      <CustomPopup
        show={popupShow}
        close={setPopupShow}
        closeIcon={true}
        id="Add Plans"
        title="Add Plans"
        bg={false}
        width="lg"
      >
        <form onSubmit={handleCourseSubmit} className="p-4">
          <h5>Select Plans:</h5>
          {["monthly", "quaterly", "yearly"].map((plan) => (
            <div key={plan} className="mb-3">
              <label className="ps-4">
                <input
                  type="checkbox"
                  checked={selectedPlans[plan]}
                  onChange={() => handlePlanToggle(plan)}
                  className="me-2"
                />
                {plan.charAt(0).toUpperCase() + plan.slice(1)} Plan
              </label>

              {selectedPlans[plan] && (
                <div className="ms-4 mt-2">
                  <input
                    type="number"
                    className="form-control mb-2"
                    placeholder="Price"
                    value={planDetails[plan].price}
                    onChange={(e) =>
                      handleInputChange(plan, "price", e.target.value)
                    }
                  />
                  <textarea
                    className="form-control"
                    placeholder="Description"
                    value={planDetails[plan].description}
                    onChange={(e) =>
                      handleInputChange(plan, "description", e.target.value)
                    }
                  />
                </div>
              )}
            </div>
          ))}

          <button type="submit" className="btn btn-primary w-100 mt-4">
            Submit
          </button>
        </form>
      </CustomPopup>
    </>
  );
};

export default AddCourse;
